import { A } from '../actions/auth';
import update from 'immutability-helper';

const initialState = {
  signIn: {
    isFetching: false,
    error: null,
  },
  signUp: {
    isFetching: false,
    error: null,
  },
  getAccountInfo: {
    isFetching: false,
    error: null,
  },
  activateAccount: {
    isFetching: false,
    error: null,
  },
  forgot: {
    isFetching: false,
    error: null,
  },
  recovery: {
    isFetching: false,
    error: null,
  },
  changePassword: {
    isFetching: false,
    error: null,
  },
  tokenData: null,
  account: null,
  privileges: localStorage.getItem('Kak2cPrivileges')
    ? JSON.parse(localStorage.getItem('Kak2cPrivileges'))
    : null,
  expirationDaysCalculateBatch: null,
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_SIGNIN:
      return update(state, {
        signIn: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_SIGNIN:
      return update(state, {
        signIn: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_SIGNIN:
      return update(state, {
        signIn: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_SIGNUP:
      return update(state, {
        signUp: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_SIGNUP:
      return update(state, {
        signUp: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_SIGNUP:
      return update(state, {
        signUp: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ACTIVATE_ACCOUNT:
      return update(state, {
        activateAccount: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ACTIVATE_ACCOUNT:
      return update(state, {
        activateAccount: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ACTIVATE_ACCOUNT:
      return update(state, {
        activateAccount: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_FORGOT:
      return update(state, {
        forgot: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_FORGOT:
      return update(state, {
        forgot: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_FORGOT:
      return update(state, {
        forgot: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_RECOVERY:
      return update(state, {
        recovery: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_RECOVERY:
      return update(state, {
        recovery: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_RECOVERY:
      return update(state, {
        recovery: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_CHANGE_PASSWORD:
      return update(state, {
        changePassword: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_CHANGE_PASSWORD:
      return update(state, {
        changePassword: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_CHANGE_PASSWORD:
      return update(state, {
        changePassword: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.SET_AUTH_TOKEN:
      return update(state, {
        tokenData: { $set: action.data },
      });

    case A.SET_PRIVILEGES:
      return update(state, {
        privileges: { $set: action.data },
      });

    case A.LOGOUT:
      return update(state, {
        tokenData: { $set: null },
        privileges: { $set: null },
      });

    case A.REQUEST_GET_ACCOUNT_INFO:
      return update(state, {
        getAccountInfo: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ACCOUNT_INFO:
      return update(state, {
        getAccountInfo: {
          isFetching: { $set: false },
        },
        account: { $set: action.data },
      });

    case A.ERROR_GET_ACCOUNT_INFO:
      return update(state, {
        getAccountInfo: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.TOGGLE_ADMIN_PANEL:
      return update(state, {
        getAccountInfo: {
          isFetching: { $set: false },
        },
        adminPanel: { $set: action.data },
      });

    case A.RECEIVE_EXPIRATION_DAYS_CALCULATE_BATCH:
      return update(state, {
        expirationDaysCalculateBatch: { $set: action.data },
      });

    default:
      return state;
  }
};

export default auth;
